import Event from './models'

export default Event
